import { call, put, take, actionChannel } from "redux-saga/effects";

import { POST, GET, PUT } from "../types/request.types";
import { requestHandler } from "./fetcher.saga";
import { buffers } from "redux-saga";
import {
  PRE_FETCH_PRODUCTS_CART,
  REQUEST_FETCH_PRODUCTS_CART,
  REQUEST_FETCH_PRODUCTS_CART_FINISHED,
  FETCH_PRODUCTS_CART,
  PRE_CREATE_ORDER_AND_USER,
  REQUEST_CREATE_ORDER_AND_USER,
  REQUEST_CREATE_ORDER_AND_USER_FINISHED,
  CREATE_ORDER_AND_USER,
  PRE_SEND_ORDER,
  REQUEST_SEND_ORDER,
  REQUEST_SEND_ORDER_FINISHED,
  SEND_ORDER,
  CREATE_ORDER,
  REQUEST_CREATE_ORDER,
  REQUEST_CREATE_ORDER_FINISHED,
  PRE_CREATE_ORDER,
  REQUEST_ADD_COMMENTS_FINISHED,
  REQUEST_ADD_COMMENTS,
  PRE_ADD_COMMENTS,
  ADD_COMMENTS,
  REQUEST_FETCH_ORDER_DATA_FINISHED,
  REQUEST_FETCH_ORDER_DATA,
  PRE_FETCH_ORDER_DATA,
  FETCH_ORDER_DATA,
  REQUEST_PREPARATION_TIME_CHOSEN_FINISHED,
  REQUEST_PREPARATION_TIME_CHOSEN,
  PRE_PREPARATION_TIME_CHOSEN,
  PREPARATION_TIME_CHOSEN,
} from "../types/order.types";

//CREATE ORDER AND USER
export function* preCreateOrderAndUser() {
  while (true) {
    const action = yield take(PRE_CREATE_ORDER_AND_USER);
    const { id_restaurant } = action;
    const nav_lang = window.navigator.language;
    yield put({
      type: REQUEST_CREATE_ORDER_AND_USER,
      body: { id_restaurant, nav_lang },
    });

    const { response } = yield take(REQUEST_CREATE_ORDER_AND_USER_FINISHED);
    yield put({
      type: CREATE_ORDER_AND_USER,
      response: response.data,
    });
  }
}

export function* watchCreateOrderAndUser() {
  const requestChan = yield actionChannel(
    REQUEST_CREATE_ORDER_AND_USER,
    buffers.expanding()
  );
  while (true) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const action = yield take(requestChan);
    const result = yield call(
      requestHandler,
      POST,
      `order/restaurant/${action.body.id_restaurant}`,
      { nav_lang: action.body.nav_lang, timezone }
    );
    yield put({
      type: REQUEST_CREATE_ORDER_AND_USER_FINISHED,
      response: result,
    });
  }
}

//CREATE
export function* preCreateOrder() {
  while (true) {
    const action = yield take(PRE_CREATE_ORDER);
    const { id_restaurant, id_user } = action;
    yield put({
      type: REQUEST_CREATE_ORDER,
      body: { id_restaurant, id_user },
    });

    const { response } = yield take(REQUEST_CREATE_ORDER_FINISHED);
    yield put({
      type: CREATE_ORDER,
      response: response.data,
    });
  }
}

export function* watchCreateOrder() {
  const requestChan = yield actionChannel(
    REQUEST_CREATE_ORDER,
    buffers.expanding()
  );
  while (true) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const action = yield take(requestChan);
    const result = yield call(requestHandler, POST, `order`, {
      idRestaurant: action.body.id_restaurant,
      idUser: action.body.id_user,
      timezone,
    });
    yield put({
      type: REQUEST_CREATE_ORDER_FINISHED,
      response: result,
    });
  }
}

export function* preFetchProductsCart() {
  while (true) {
    const action = yield take(PRE_FETCH_PRODUCTS_CART);
    const { id_order, id_restaurant } = action;
    yield put({
      type: REQUEST_FETCH_PRODUCTS_CART,
      body: { id_order, id_restaurant },
    });

    const { response } = yield take(REQUEST_FETCH_PRODUCTS_CART_FINISHED);
    yield put({
      type: FETCH_PRODUCTS_CART,
      response: { foundProducts: response.data.result },
    });
  }
}

export function* watchFetchProductsCart() {
  const requestChan = yield actionChannel(
    REQUEST_FETCH_PRODUCTS_CART,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);
    const result = yield call(
      requestHandler,
      GET,
      `orderLine/${action.body.id_order}/${action.body.id_restaurant}`
    );
    yield put({
      type: REQUEST_FETCH_PRODUCTS_CART_FINISHED,
      response: result,
    });
  }
}

export function* preSendTheOrder() {
  while (true) {
    const action = yield take(PRE_SEND_ORDER);
    const { id_order } = action;
    yield put({
      type: REQUEST_SEND_ORDER,
      body: {
        id_order,
      },
    });

    yield take(REQUEST_SEND_ORDER_FINISHED);
    yield put({
      type: SEND_ORDER,
    });
  }
}

export function* watchSendTheOrder() {
  const requestChan = yield actionChannel(
    REQUEST_SEND_ORDER,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);
    const result = yield call(
      requestHandler,
      POST,
      `order/order-status/`,
      action.body
    );
    yield put({
      type: REQUEST_SEND_ORDER_FINISHED,
      response: result,
    });
  }
}

export function* preAddComments() {
  while (true) {
    const action = yield take(PRE_ADD_COMMENTS);
    const { id_order, text_value } = action;
    yield put({
      type: REQUEST_ADD_COMMENTS,
      body: { id_order, text_value, update: "text" },
    });

    const { response } = yield take(REQUEST_ADD_COMMENTS_FINISHED);
    yield put({
      type: ADD_COMMENTS,
      response: response.status === 200 ? text_value : "",
    });
  }
}

export function* watchAddComments() {
  const requestChan = yield actionChannel(
    REQUEST_ADD_COMMENTS,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);
    const result = yield call(
      requestHandler,
      PUT,
      `order/order-data/${action.body.id_order}`,
      action.body
    );
    yield put({
      type: REQUEST_ADD_COMMENTS_FINISHED,
      response: result,
    });
  }
}

export function* preAddTimeTakeAway() {
  while (true) {
    const action = yield take(PRE_PREPARATION_TIME_CHOSEN);
    const { id_order, time_stamps } = action;
    yield put({
      type: REQUEST_PREPARATION_TIME_CHOSEN,
      body: { id_order, time_stamps, update: "time" },
    });

    const { response } = yield take(REQUEST_PREPARATION_TIME_CHOSEN_FINISHED);
    yield put({
      type: PREPARATION_TIME_CHOSEN,
      response: response.status === 200 ? time_stamps : false,
    });
  }
}

export function* watchAddTimeTakeAway() {
  const requestChan = yield actionChannel(
    REQUEST_PREPARATION_TIME_CHOSEN,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);
    const result = yield call(
      requestHandler,
      PUT,
      `order/order-data/${action.body.id_order}`,
      action.body
    );
    yield put({
      type: REQUEST_PREPARATION_TIME_CHOSEN_FINISHED,
      response: result,
    });
  }
}

export function* preFetchOrderData() {
  while (true) {
    const action = yield take(PRE_FETCH_ORDER_DATA);
    const { id_order, id_restaurant } = action;
    yield put({
      type: REQUEST_FETCH_ORDER_DATA,
      body: { id_order, id_restaurant },
    });

    const { response } = yield take(REQUEST_FETCH_ORDER_DATA_FINISHED);
    yield put({
      type: FETCH_ORDER_DATA,
      response: response.data,
    });
  }
}

export function* watchFetchOrderData() {
  const requestChan = yield actionChannel(
    REQUEST_FETCH_ORDER_DATA,
    buffers.expanding()
  );
  while (true) {
    const action = yield take(requestChan);
    const result = yield call(
      requestHandler,
      GET,
      `order/order-data/${action.body.id_order}/${action.body.id_restaurant}`
    );
    yield put({
      type: REQUEST_FETCH_ORDER_DATA_FINISHED,
      response: result,
    });
  }
}